export function replaceColorsInObject(objectToChange, colorMapping) {
  const keys = Object.keys(colorMapping);
  if (keys.length === 0) return objectToChange;

  // Build a single regex that matches any of the keys (global)
  const regexPattern = keys.map(key => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  const regex = new RegExp(`(${regexPattern})`, 'g');

  for (let prop in objectToChange) {
    if (objectToChange.hasOwnProperty(prop) && typeof objectToChange[prop] === 'string') {
      objectToChange[prop] = objectToChange[prop].replace(regex, match => colorMapping[match]);
    }
  }

  return objectToChange;
}